import { curry, type PlatformEvent } from 'lib/util'

/**
 * Sets the action's `stopReport` state, so that a report generation in progress is stopped.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const stopReport = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent
) => {
  const actionState = module[G.STATE][G.ACTION][G.STATE]

  if (actionState.generatingReport) {
    actionState.stopReport = true

    return await new Promise((resolve, reject) => {
      actionState.onReportStopped = (success: boolean) => success ? resolve(success) : reject()
    })
  }

}

export default curry(stopReport)
